import { select } from 'redux-saga/effects';
import { selectCanManagePrivateWhiteboards } from 'features/permissions/permissionsSlice';

export function* hasPrivateWhiteboardAccessSaga(isPrivate: boolean) {
  if (!isPrivate) {
    return true;
  }

  const canManagePrivateWhiteboard: boolean = yield select(selectCanManagePrivateWhiteboards);
  return canManagePrivateWhiteboard;
}
